import { useCallback } from 'react';

function useFileDownloader() {
  const downloadFile = useCallback((url?: string, filename?: string) => {
    console.log('Downloading file:', url, filename);
    if (!url) return;

    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'file';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  return downloadFile;
}

export default useFileDownloader;
